'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('../constants');

var _collection = require('./collection');

var _collection2 = _interopRequireDefault(_collection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MeetingsUtil = {};

MeetingsUtil.extractDestination = function (destination, type) {
  var dest = destination;
  if (type === _constants.LOCUS_ID) {
    if (!(destination && destination.url)) {
      throw new Error('You cannot create a meeting by locus without a locus.url defined');
    }
    var temp = destination.url.split('/');
    dest = temp[temp.length - 1];
  }
  return dest;
};

MeetingsUtil.getMeetingAddedType = function (type) {
  return type === _constants.LOCUS_ID ? _constants.INCOMING : _constants.CREATED;
};

MeetingsUtil.handleRoapMercury = function (envelope) {
  var data = envelope.data;
  var eventType = data.eventType;

  if (eventType === _constants.LOCUSEVENT.MESSAGE_ROAP) {
    var meeting = _collection2.default.getByKey(_constants.CORRELATION_ID, data.correlationId);
    if (meeting) {
      meeting.roap.roapEvent(data);
    } else {
      console.error('no meeting associated to roap event');
      // This should never happen
    }
  }
};

exports.default = MeetingsUtil;
//# sourceMappingURL=util.js.map
